import axios from "axios";

const PUBLIC_PASSWORD_ENDPOINTS = new Set([
    "/auth/change-password",
    "/auth/reset-password",
]);
export const canRedirectToLoginOnUnauthorized = (url) => {
    const requestPath = url?.split("?")[0].replace(/\/+$/, "") ?? "";
    return ![...PUBLIC_PASSWORD_ENDPOINTS].some((endpoint) => requestPath.endsWith(endpoint));
};

const createAxiosInstance = (baseURL) => {
    const instance = axios.create({
        baseURL,
        timeout: 30000,
        headers: {
            "Content-Type": "application/json",
        },
    });
    instance.interceptors.request.use((config) => {
        const token = localStorage.getItem("authToken");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    }, (error) => Promise.reject(error));
    instance.interceptors.response.use((response) => response, (error) => {
        const apiError = {
            message: error.response?.data?.message ||
                error.message ||
                "エラーが発生しました",
            code: error.response?.data?.code,
            status: error.response?.status,
        };
        if (error.response?.status === 401 &&
            canRedirectToLoginOnUnauthorized(error.config?.url)) {
            localStorage.removeItem("authToken");
            window.location.href = "/login";
        }
        return Promise.reject(apiError);
    });
    return instance;
};
// Vite環境変数を使用（ブラウザ環境で動作）
const getApiBaseUrl = () => {
    if (typeof import.meta !== "undefined" &&
        import.meta.env?.VITE_API_BASE_URL) {
        return import.meta.env.VITE_API_BASE_URL;
    }
    return "http://localhost:3000/api/v1";
};
export const api = createAxiosInstance(getApiBaseUrl());
export default api;
